/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_ExpiringInputs */

const en_plan_expiring = /** @type {(inputs: Plan_ExpiringInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Your current plan will expire soon.`);
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Your current plan will expire in ${i?.count} day.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Your current plan will expire in ${i?.count} days.`);
	return /** @type {LocalizedString} */ ("plan_expiring");
};

const es_plan_expiring = /** @type {(inputs: Plan_ExpiringInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Tu plan actual expirará pronto.`);
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Tu plan actual expirará en ${i?.count} día.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Tu plan actual expirará en ${i?.count} días.`);
	return /** @type {LocalizedString} */ ("plan_expiring");
};

/**
* | count | countPlural | output |
* | --- | --- | --- |
* | "0" | * | "Your current plan will expire soon." |
* | * | "one" | "Your current plan will expire in {count} day." |
* | * | "other" | "Your current plan will expire in {count} days." |
*
* @param {Plan_ExpiringInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_expiring = /** @type {((inputs: Plan_ExpiringInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ExpiringInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_expiring(inputs)
	return en_plan_expiring(inputs)
});